export const patternFormats = [
  { code: 'CNPJ', format: '##.###.###/####-##'},
  { code: 'CPF', format: '###.###.###-##'},
  { code: 'CM', format: '###.###-#'},
  { code: 'IE', format: '###.###.###.###'},
  { code: 'IM', format: '###.###.###-##'},
  { code: 'phone', format: '+55 (##) #####-####' },
  { code: 'date', format: '##/##/####' }
];
